import { settingsCache } from "./settingsCache";

export function formatPrice(value) {
  return `${settingsCache.currencySymbol}${Number(value).toFixed(2)}`;
}
